import { Platform, Dimensions } from 'react-native';

export const isIOS = Platform.OS === 'ios';
export const isAndroid = Platform.OS === 'android';
export const isWeb = Platform.OS === 'web';
export const isMobile = isIOS || isAndroid;

export function getScreenDimensions() {
  return Dimensions.get('screen');
}

export function getWindowDimensions() {
  return Dimensions.get('window');
}

export function isTablet(): boolean {
  const { width, height } = getScreenDimensions();
  const aspectRatio = width / height;
  const minDimension = Math.min(width, height);

  return minDimension >= 600 && aspectRatio > 1.2 && aspectRatio < 2.1;
}

export function isLandscape(): boolean {
  const { width, height } = getWindowDimensions();
  return width > height;
}

export function getSafeAreaInsets() {
  return {
    top: isIOS ? 44 : 24,
    bottom: isIOS ? 34 : 0,
    left: 0,
    right: 0,
  };
}

export function platformSelect<T>(values: {
  ios?: T;
  android?: T;
  web?: T;
  default?: T;
}): T | undefined {
  if (isIOS && values.ios !== undefined) return values.ios;
  if (isAndroid && values.android !== undefined) return values.android;
  if (isWeb && values.web !== undefined) return values.web;
  return values.default;
}

export function getPlatformFontFamily(_fontWeight: string = 'normal'): string {
  return (
    platformSelect({
      ios: 'System',
      android: 'Roboto',
      web: 'Inter, system-ui, sans-serif',
      default: 'System',
    }) || 'System'
  );
}

export function supportsHaptics(): boolean {
  return isMobile;
}

export function supportsBiometrics(): boolean {
  return isMobile;
}

export function getKeyboardBehavior():
  | 'padding'
  | 'height'
  | 'position'
  | undefined {
  return platformSelect<'padding' | 'height' | 'position' | undefined>({
    ios: 'padding',
    android: 'padding', // Changed from 'height' to 'padding' to match type
    web: undefined,
  });
}
